import { FormattedMessage } from 'react-intl';
import { styled } from '@mui/material/styles';

// Placeholder for a filter section whose options failed to load, so the
// section reads as unavailable rather than as having no options.
const FilterOptionsUnavailable = () => (
  <Root>
    <FormattedMessage
      id="filterOptionsUnavailable"
      defaultMessage="Options unavailable"
    />
  </Root>
);

const Root = styled('div')(({ theme }) => ({
  padding: `${theme.spacing(1)} 0`,
  color: theme.palette.grey400,
  fontSize: 14,
  lineHeight: '20px',
}));

export default FilterOptionsUnavailable;
